import React, { useEffect } from "react";
import { auth } from "../firebase-config";
import Logo from '../assets/Logo.svg';
import { onAuthStateChanged } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { setUid } from "../redux/userReducer";
import { useDispatch } from "react-redux";

const Header = () => {


    const navigate = useNavigate()
    const dispatch = useDispatch()

    useEffect(() => {
        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (!user) {
                navigate('/login')
            } else {
                dispatch(setUid(user.uid))
            }
        })
        return () => unsubscribe()
    }, [])

    return (<div style={{ borderBottom: '1px solid #d3d3d3', paddingBottom: '10px', display: 'flex', alignItems: 'center', width: '100%', boxSizing: 'border-box' }}>
        <div className="headerBrand">
            <img src={Logo} alt="Upskill Institute" />
            <small>Training Portal</small>
        </div>
        <span className="headerCurrentDate">
            <svg aria-hidden="true" width="29" height="29" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="5" width="18" height="16" rx="2"/><path d="M16 3v4M8 3v4M3 10h18"/></svg>
            <span className="headerCurrentDateText">
                <strong>{new Intl.DateTimeFormat('en-AU', { weekday: 'long' }).format(new Date())}</strong>
                <span>{new Intl.DateTimeFormat('en-AU', { day: '2-digit', month: 'short', year: 'numeric' }).format(new Date())}</span>
            </span>
        </span>
    </div>)
}

export default Header
